// 未保存変更確認サービス
// ダイアログ呼び出し責務をguardから分離し集約する

import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';

import {
  UnsavedChangesDialogComponent,
  type UnsavedChangesDialogResult,
} from './unsaved-changes-dialog/unsaved-changes-dialog.component';

/**
 * 未保存変更確認ダイアログの呼び出しを担うサービス
 * guard から Dialog の組み立て責務を分離する
 */
@Injectable({ providedIn: 'root' })
export class UnsavedChangesConfirmService {
  private readonly dialog = inject(MatDialog);

  /**
   * 未保存変更確認ダイアログを表示し、ユーザーの選択を返す
   * @returns ユーザーが「保存せずに離れる」を選択した場合 true、それ以外は false
   */
  async confirm(): Promise<boolean> {
    const dialogRef = this.dialog.open<
      UnsavedChangesDialogComponent,
      undefined,
      UnsavedChangesDialogResult
    >(UnsavedChangesDialogComponent, {
      width: '420px',
      disableClose: true,
    });

    const result = await firstValueFrom(dialogRef.afterClosed());
    return result?.confirmed ?? false;
  }
}
